import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection, { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl, menuToggler } from '@bd/bdcore-utilities';

const styles = css`
  position: fixed;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0;
  overflow-y: scroll;
  z-index: 100;
  display: none;
  @media (min-width: 992px) {
    top: 80px;
  }
  &.HeaderMenu-active {
    display: block;
  }
  .HeaderMenu_menuClose {
    background:rgba(255,255,255,.9);
    display: block;
    position: fixed;
    right: 0;
    top: 60px;
    bottom:0;
    width: 100vw;
    height: calc(100vh - 60px);
    padding: 0;
    box-sizing: content-box;
    border:0;
    @media (min-width: 992px) {
      height: calc(100vh - 80px);
      top: 80px;
    }
  }
  .HeaderMenu_menu {
    background:white;
    position: fixed;
    overflow-y: scroll;
    top: 60px;
    right:0;
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;
    width:100%;
    height: calc(100vh - 60px);
    max-width: 480px;
    padding-bottom:60px;
    @media (min-width: 992px) {
      top: 80px;
      height: calc(100vh - 80px);
    }
  }
  .HeaderMenu_menuItem {
    list-style: none;
    position: relative;
    width: 100%;
    background-size: cover;
    background-position: center;
    margin-bottom: 10px;
  }
  .HeaderMenu_menuItem:before {
    content:'';
    padding-top:50%;
    display: block;
  }
  .HeaderMenu_menuItem a {
    background: rgba(0,0,0,.2);
    position:absolute;
    top:0px;
    right:0px;
    bottom:0;
    left:0px;
    display: flex;
    flex-flow:column nowrap;
    justify-content: flex-end;
    padding:10px;
    color:white;
    font-weight:700;
    transition: all .25s ease;
  }
  .HeaderMenu_menuItem:last-child a  {
    position:absolute;
    top:0px;
    right:0px;
    bottom:0px;
    left:0px;
    display: flex;
    flex-flow:column nowrap;
    justify-content: flex-end;
    margin-bottom:0;
  }
  .HeaderMenu_menuItem a:hover {
    background: rgba(0,0,0,0);
  }
  .HeaderMenu_menuHeading {
    font-size: 18px;
    font-weight: 800;
    padding: 15px 0;
    background-image: url('/images/icon-triangle.svg');
    background-position: calc(100% - 15px) center;
    background-repeat: no-repeat;
    cursor: pointer;
    display: block;
    @media (min-width: 992px) {
      font-weight: 400;
      font-size: 15px;
      background-image: none;
      cursor: default;
      position: relative;
      padding: 0 15px;
      line-height: 100px;
      height: 100px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover {
        background-color: #eeeeee;
      }
    }
  }
  .HeaderMenu_subMenu {
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    position: relative;
    @media (min-width: 992px) {
      position: absolute;
      top: 100px;
      left: 0;
      width: auto;
      min-width: 200px;
      background-color: #FFFFFF;
    }
  }
  .HeaderMenu_menuItem:last-child .HeaderMenu_subMenu {
    @media (min-width: 992px) {
      left: auto;
      right: 0;
    }
  }
  .HeaderMenu_subMenu-active {
    display: block;
  }
  .HeaderMenu_subMenuItem a {
    color: #666666;
    padding: 5px 10px;
    display: block;
    transition: all .3s ease;
    &:hover {
      background-color: #eeeeee;
    }
  }
`;

function HeaderMenu({ isActive, toggleMenu, widget }) {
  return (
    <div className={`${styles} ${isActive ? 'HeaderMenu-active' : ''}`} >
      <button className="HeaderMenu_menuClose" onClick={toggleMenu} />
      <ul className="HeaderMenu_menu">
        {
          get(widget, 'navigation_list', []).map(item => (
            <li className="HeaderMenu_menuItem" style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'background_image.contentUrl'), { width: 1200, height: 1200 })}')` }} >
              <Link name={get(RouteCollection.getRouteByPath(get(item, 'route', 'index')), 'name', 'index')}>{get(item, 'name', '')}</Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

HeaderMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  widget: PropTypes.object.isRequired,
};

export default menuToggler(withData(
  {
    widget: 'main_navigation',
  },
)(HeaderMenu));



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js